import {type} from '../action'
// import ReadingStudent from "../../components/StudentProfile/ReadingStudent/ReadingStudent";
// import HistoricalStudent from "../../components/StudentProfile/HistoricalStudent/HistoricalStudent";
const initialState = {
    CRM_MENU: JSON.parse(localStorage.getItem('CRM_MENU') || '[]') , // 运营系统主菜单
    SideBarMenu: JSON.parse(localStorage.getItem('SideBarMenu') || '[]') , // 运营系统侧边栏菜单
    OpenKeys: JSON.parse(localStorage.getItem('OpenKeys')), // 默认展开
    SelectedKeys: JSON.parse(localStorage.getItem('SelectedKeys')), // 默认选中
    ActiveKey: null, // 默认选中
    FillInReportSearch: { // 校区列表
        searchParam: '', // 学员姓名/账号
        SubjectIds: [], // 学科ID
        identityID: null, // 身份ID
        userType: null, // 学员类型
        littleCate: null, // 学员类型 二级
        reportStatus: null, // 填报状态
    },
    CampusInfoSearch: { // 校区数据表
        searchParam: '', // 学员姓名/账号
        SubjectIds: [], // 学科ID
        identityID: null, // 身份ID
        userType: null, // 学员类型
        littleCate: null, // 学员类型 二级
        reportStatus: null, // 填报状态
    },
    OurSchoolInfoSearch: { // 本校数据
        searchParam: '', // 学员姓名/账号
        SubjectIds: [], // 学科ID
        identityID: null, // 身份ID
        userType: null, // 学员类型
        littleCate: null, // 学员类型 二级
        reportStatus: null, // 填报状态
    },
    YiXunRextend: null,
    CallCenterStatus: 1, // 话机状态
    CallCenterStatusName: '未签入', // 话机状态名称
    AdvertisementInfo: {}, // 公告消息
    HighSeasSearch: {
        param: {

        },
        pageIndex: 1,
        pageSize: 10,
        sort: "",
        sortBy: ""
    },
    CitySearch: {
        param: {

        },
        pageIndex: 1,
        pageSize: 10,
        sort: "",
        sortBy: ""
    },
    SaleCenter_Potential: { // 销售中心-潜在学员搜索条件
        param: {
        },
        pageIndex: 1,
        pageSize: 10,
        sort: "",
        sortBy: ""
    },
    DingClass_Params: { //钉钉班级条件
        param: {
        },
        pageIndex: 1,
        pageSize: 10,
        sort: "",
        sortBy: ""
    },
    DingStudent_Params: { //钉钉学员条件
        param: {},
        pageIndex: 1,
        pageSize: 10,
        sort: "",
        sortBy: ""
    },
    SaleCenter_Reading: { // 销售中心-在读学员搜索条件
        param: {
        },
        pageIndex: 1,
        pageSize: 10,
        sort: "",
        sortBy: ""
    },
    SaleCenter_Historical: { // 销售中心-历史学员搜索条件
        param: {},
        pageIndex: 1,
        pageSize: 10,
        sort: '',
        sortBy: '', //排序-根据首次报名时间
    },
    EC_Historical: {
        param: {
        },
        pageIndex: 1,
        pageSize: 10,
        sort: '',
        sortBy: '', //排序-根据首次报名时间
    }, // 教务中心-历史学员搜索条件
    EC_Reading: {
        param: {
        },
        pageIndex: 1,
        pageSize: 10,
        sort: '',
        sortBy: '', //排序-根据首次报名时间
    }, // 教务中心-在读学员搜索条件
    OrderManage_Search: {}, // 订单管理搜索条件
    ClassLessonSearch: {

    },
    Audition_Lesson: {
        params: {
        },
        pageIndex: 1,
        pageSize: 10,
        sort: '',
        sortBy: '',
    }, //邀约管理-试听课搜索条件
    navigationList: {

    }, // 三级导航
    RC_Date:{
        timeRange:''
    },//备课磨课日期


    isShowInfo:false,    //是否打开预览
    searchInfo:{},    //案例管理
    activationPointCount:0, //服务点学员强提醒
}

export default (state = initialState, action) => {
    switch (action.type) {
        case type.ACTIVATIONPOINTCOUNT:
            return {
                ...state,
                activationPointCount: action.num,
            }
        case type.CRM_MENU:
            return {
                ...state,
                CRM_MENU: action.CRM_MENU,
            }
        case type.SIDEBAR_MENU:
            return {
                ...state,
                SideBarMenu: action.SideBarMenu,
                OpenKeys: action.OpenKeys ? action.OpenKeys : state.OpenKeys,
                SelectedKeys: action.SelectedKeys ? action.SelectedKeys : state.SelectedKeys,
                ActiveKey: action.ActiveKey ? action.ActiveKey : state.ActiveKey,
            }
        case type.SWITCH_MENU:
            return {
                ...state,
                defaultOpenKeys: action.defaultOpenKeys,
                defaultSelectedKeys: action.defaultSelectedKeys,
            }
        case type.REPORT_SEARCH:
            return {
                ...state,
                FillInReportSearch: action.FillInReportSearch
            }
        case type.CAMPUS_SEARCH:
            return {
                ...state,
                CampusInfoSearch: action.CampusInfoSearch
            }
        case type.OURSCHOOL_SEARCH:
            return {
                ...state,
                OurSchoolInfoSearch: action.OurSchoolInfoSearch
            }
        case type.YIXUN_REXTEND:
            return {
                ...state,
                YiXunRextend: action.YiXunRextend,
            }
        case type.CALL_STATUS:
            return {
                ...state,
                CallCenterStatus: action.CallCenterStatus,
                CallCenterStatusName:  action.CallCenterStatusName,
            }
        case type.AD_INFO:
            return {
                ...state,
                AdvertisementInfo: action.AdvertisementInfo
            }
        case type.SALECENTER_POTENTIAL:
            return {
                ...state,
                SaleCenter_Potential: action.SaleCenter_Potential,
            }
        case type.DingClass_Params:
            return {
                ...state,
                DingClass_Params: action.DingClass_Params,
            }
        case type.DingStudent_Params:
            return {
                ...state,
                DingStudent_Params: action.DingStudent_Params,
            }
        case type.SALECENTER_READING:
            return {
                ...state,
                SaleCenter_Reading: action.SaleCenter_Reading,
            }
        case type.SALECENTER_HISTORICAL:
            return {
                ...state,
                SaleCenter_Historical: action.SaleCenter_Historical,
            }
        case type.EC_READING:
            return {
                ...state,
                EC_Reading: action.EC_Reading,
            }
        case type.CLASSLESSON_SEARCH:
            return {
                ...state,
                ClassLessonSearch: action.ClassLessonSearch,
            }
        case type.EC_HISTORICAL:
            return {
                ...state,
                EC_Historical: action.EC_Historical,
            }
        case type.AUDITION_LESSON:
            return {
                ...state,
                Audition_Lesson: action.Audition_Lesson
            }
        case type.SIDER_CUSTOM:
            return {
                ...state,
                navigationList: action.navigationList
            }
        case type.READY_COURSE_DATE:
            return {
                ...state,
                RC_Date: action.RC_Date,
            }
        case type.IS_SHOW_CASE_INFO:
            return {
                ...state,
                isShowInfo: action.isShowInfo,
            }
        case type.CANSE_MANAGE_SEARCH:
            return {
                ...state,
                searchInfo: action.searchInfo,
            }   
        case type.HEADQUARTERS_SEARCH:
            return {
                ...state,
                HighSeasSearch: action.HighSeasSearch,
            }
        case type.City_Search:
            return {
                ...state,
                CitySearch: action.CitySearch,
            }
        default:
            return state;
    }
}
